attachEvent('.info-bar__close', 'click', (ev) => {
  const parentElem = ev.target.closest('.sc-info-bar');
  parentElem.style.display = 'none';
  ev.preventDefault();
});
